import * as React from 'react';

import { Headline, Image, SubHeadline, View } from '../common';

const Error: React.FC = () => (
  <View>
    <Image>
      <Headline>500</Headline>
      <SubHeadline>
        Something has gone wrong. This shouldn't happen, but it did.
      </SubHeadline>
    </Image>
  </View>
);

export default Error;
